document.addEventListener("DOMContentLoaded", function(){

  document.querySelectorAll('.clip-btn').forEach(function(btn){

    btn.addEventListener('click',function(){

      let couponCard = this.closest('.yb-coupon');

      let codeElement = couponCard.querySelector('.yb-code');

      if(!codeElement){
        return;
      }

      let code = codeElement.innerText.trim();

      navigator.clipboard.writeText(code);

      let area = this.closest('.clip-area');

      area.classList.add("active");

      this.style.display="none";

      showToast("Coupon Clipped ✔");

    });

  });

});


function showToast(msg){

  let toast = document.createElement("div");

  toast.innerText = msg;

  toast.style.position="fixed";
  toast.style.bottom="30px";
  toast.style.left="50%";
  toast.style.transform="translateX(-50%)";
  toast.style.background="#0a9b3f";
  toast.style.color="#fff";
  toast.style.padding="10px 18px";
  toast.style.borderRadius="8px";
  toast.style.zIndex="99999";
  toast.style.fontWeight="600";
  toast.style.fontSize="14px";

  document.body.appendChild(toast);

  setTimeout(function(){
    toast.remove();
  },2000);

}